import { Component } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { faKey } from '@fortawesome/free-solid-svg-icons';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { MembershipService } from 'app/core/services/membership.service';
import { MustMatch } from 'app/core/validators/must-match.validator';
import { NexusFormResultModel } from 'app/models/nexus-form-result.model';
import { ResetPasswordModel } from 'app/models/reset-password.model';
import { faTimesCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { PasswordStrengthValidator } from 'app/core/validators/password-strengh.validator';
import { ForgotPasswordModel } from 'app/models/forgot-password.model';
@Component({
  selector: 'app-set-password',
  templateUrl: './set-password.component.html',
  styleUrls: ['./set-password.component.scss']
})
// This is component is also used for  forgot/reset password
export class SetPasswordComponent extends NexusComponent {
// this field is used show header text set password or reset password
  // this value is set in the route
  public page_header_text: string;
  // this field is used to differentiate set and reset actions
  // this value is set in the route
  public path: string;
  public reset_model: ResetPasswordModel = new ResetPasswordModel();
  public form_result: NexusFormResultModel = new NexusFormResultModel();
  public reset_password: boolean = true;
  public form: UntypedFormGroup;
  faTimesCircle =faTimesCircle;
  faCheckCircle =faCheckCircle;
  public faKey = faKey;

  constructor(private route: ActivatedRoute, private membership_service: MembershipService, private formBuilder: UntypedFormBuilder) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.form = this.formBuilder.group({
      password: ['', [Validators.required,PasswordStrengthValidator()]],
      confirm_password: ['', Validators.required]
    },
      {
        validator: MustMatch('password', 'confirm_password')
      });

    this.form.valueChanges.subscribe((form_data: any) => {
      this.PopulateModelFromForm(form_data, this.reset_model);
    });
    this.route.data.subscribe(({ reset_password_model , page_header_text, path}) => {
      this.reset_model = reset_password_model;
      this.page_header_text = page_header_text;
      this.path = path;
      if(this.reset_model){
        this.reset_model.client_id= "client-portal";
      }
    });

  }

  get showPasswordErrors() {
    if(this.form .controls.password.errors?.required == true ){
      return false;
    }
    return !(this.form .controls.password.errors == null)
  }
  get passwordErrors() {
      return this.form .controls.password.errors?.password_strength || {};
  }
  get confirmPasswordErrors() {
    return (this.form .controls.confirm_password.errors == null);

  }
  get showConfirmPasswordErrors() {
    return !this.form .controls.confirm_password.errors?.required;
  }

  submit() {
    this.form_result.Reset();

    if (!this.validatePasswordConfirmation()) {
      this.form_result.Error('Passwords Must Match');
      return;
    }

    if (this.form.invalid) {
      this.form_result.Incomplete();
      return;
    }

    this.StartSpinner();
    this.membership_service.ResetPassword(this.reset_model).subscribe(
      data => {
        if(this.path == 'reset-password')
          {
            this.form_result.Success("Reset Successful, please navigate to <a href=\"/login\">Login</a> to proceed.");
          }
          else{
            this.form_result.Success("Your password has been set successfully. Please navigate to the <a href=\"/login\">Login</a> to proceed.");
          }
        this.StopSpinner();
      },
      error => {
        this.form_result.Error(error);
        this.StopSpinner();
      });
  }

  public validatePasswordConfirmation(): boolean {
    let valid = false;
    if (this.form) {
      var newPassword = this.form.get('password').value;
      var confirmPassword = this.form.get('confirm_password').value;

      if (newPassword && confirmPassword && newPassword == confirmPassword) {
        valid = true;
      }
    }
    return valid;
  }
  submit_reset_password(){
    this.StartSpinner();
    if(this.path == 'reset-password')
      {
        var forgot_model: ForgotPasswordModel = new ForgotPasswordModel();
        forgot_model.client_id = this.reset_model.client_id;
        forgot_model.email = this.reset_model.user_email;
        this.membership_service.ForgotPassword(forgot_model).subscribe(
          data => { this.show_success('Your password reset email has been sent to your registered email address.');},
          error => { this.show_error(error); }
        )
      }
      else{
        this.membership_service.ResendPasswordLink(this.reset_model).subscribe(
          data => { this.show_success('Your password reset email has been sent to your registered email address.');},
          error => { this.show_error(error); }
        );
      }
  }

  show_success(msg){
    this.form_result.Success(msg);
    this.StopSpinner();

  };
  show_error(error)
  {
    this.form_result.Error(error);
    this.StopSpinner();
  };
}
